module.exports = __webpack_public_path__ + "img/icons_9.6dfc7411.svg";